import type { ComponentType } from "react";
import { SEOHead } from "@/components/SEOHead";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";

import FramedSection from "@/components/FramedSection";
import CapabilityCarousel from "@/components/CapabilityCarousel";
import ChatAnyChannel from "@/components/ChatAnyChannel";
import WhyManeVideo from "@/components/WhyManeVideo";
import TestimonialsWall from "@/components/TestimonialsWall";
import StatRowSection from "@/components/StatRowSection";
import BrainMCP from "@/components/BrainMCP";
import ManePlatform from "@/components/ManePlatform";
import TheStack from "@/components/IntegrationsRotator";
import DashboardShowcase from "@/components/DashboardShowcase";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
const Section = ({
  as: Cmp,
}: {
  as: ComponentType;
  minHeight?: number;
}) => <Cmp />;

const Index = () => {

  return (
  <div className="min-h-screen bg-background text-foreground">
    <SEOHead
      title="Autonomous AI Agent Team Built on Claude Code | Mane"
      description="40+ specialist AI agents that research, code, write, find leads, and ship, running locally on your Claude Code. Works from Slack, Telegram, or your terminal."
      url="https://mane.dev"
      image="https://mane.dev/og.jpg"
      schema={{
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "WebSite",
            name: "Mane",
            url: "https://mane.dev",
            potentialAction: {
              "@type": "SearchAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate: "https://mane.dev/use-cases?q={search_term_string}",
              },
              "query-input": "required name=search_term_string",
            },
          },
          {
            "@type": "SoftwareApplication",
            name: "Mane",
            url: "https://mane.dev",
            applicationCategory: "BusinessApplication",
            operatingSystem: "Web, macOS, Windows, Linux",
            description: "40+ specialist AI agents that research, code, write, find leads, and ship, running locally on your Claude Code.",
            offers: [
              { "@type": "Offer", price: "0", priceCurrency: "USD", name: "Free" },
              { "@type": "Offer", price: "40", priceCurrency: "USD", name: "Pro" },
              { "@type": "Offer", price: "120", priceCurrency: "USD", name: "Scale" },
            ],
            publisher: { "@type": "Organization", name: "Mane", url: "https://mane.dev" },
          },
        ],
      }}
    />
    <Navbar variant="overlay" />

    <main id="main-content">
    <Hero />

    <CapabilityCarousel />

    <FramedSection pattern="grid">
      <Section as={DashboardShowcase} minHeight={780} />
    </FramedSection>

    <Section as={ChatAnyChannel} minHeight={400} />


    <Section as={WhyManeVideo} minHeight={760} />

    <FramedSection pattern="noise">
      <Section as={TheStack} minHeight={760} />
    </FramedSection>

    <FramedSection pattern="noise">
      <Section as={BrainMCP} minHeight={760} />
    </FramedSection>

    <FramedSection pattern="noise">
      <Section as={ManePlatform} minHeight={820} />
    </FramedSection>


    <FramedSection pattern="noise">
      <Section as={TestimonialsWall} minHeight={640} />
    </FramedSection>

    <FramedSection pattern="noise">
      <Section as={StatRowSection} minHeight={300} />
    </FramedSection>



    <FramedSection noBottom>
      <Section as={FinalCTA} minHeight={340} />
    </FramedSection>
    </main>

    <Section as={Footer} minHeight={300} />

  </div>
  );
};

export default Index;
